import Vue from 'vue'
import apiClient from '../../axios';

const state = {
};

const mutations = {
};

const actions = {
  purchasePremiumByToken: ({commit}, formData) => {
    return apiClient.post("webstore/subscription/purchase/token", formData)
      .then((results) => {
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  },
  cancelPremium: ({commit}, formData) => {
    return apiClient.post("webstore/subscription/purchase/cancel", formData)
      .then((results) => {
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  },
  upgradeByToken: ({commit}, formData) => {
    return apiClient.post("webstore/subscription/upgrade/token", formData)
      .then((results) => {
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  },
  purchaseUnlimitedByToken: ({commit}, formData) => {
    return apiClient.post("webstore/subscription/unlimited/purchase/token", formData)
      .then((results) => {
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  },
  cancelUnlimited: ({commit}, formData) => {
    return apiClient.post("webstore/subscription/unlimited/purchase/cancel", formData)
      .then((results) => {
          return results.data;
        },
      )
      .catch((err) => {
        return err.response.data
      });
  }
};

const getters = {
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/premiumpayment.js